import type { Method } from 'lib/axios';
import { APICallV1 } from 'reactApp/api/APICall';
interface Profile {
    ctime: number;
    email: string;
    extra_email: string;
    properties: {
        cleaner_intervals_count?: string;
        failed_prolong?: string;
        gdpr_eula?: string;
        gdpr_pp?: string;
        'ios.onboarding_recognition_version'?: string;
        la_acceptance_time?: string;
        la_version?: string;
        licence_gdpr_revision?: string;
        registration_date?: string;
        root_tree_ctime?: string;
        upload_files_web?: string;
        'tg.session'?: string;
        'tg.status'?: string;
        'tg.cursor'?: string;
    };
    version: number;
    devices: {
        [deviceId: string]: {
            ctime: number;
            flags: Record<string, unknown>;
            name: string;
            properties?: {
                autoload_image?: string;
                autoload_video?: string;
                country?: string;
                language?: string;
                push_notifications?: string;
                push_tags?: string;
                timezone?: string;
                autoload_general?: string;
                permission_gallery?: string;
                permission_geo?: string;
                autoload_image_mobile?: string;
                autoload_video_mobile?: string;
            };
            platform: string;
            utime?: number;
        };
    };
}

export interface ProfileResponse {
    code: string;
    profile: Profile;
}

export type TProfileGetFull = {
    did: string;
};

export class ProfileFullApiCall extends APICallV1<ProfileResponse, TProfileGetFull> {
    _method = 'profile/full_profile';
    _type: Method = 'post';
    defaultData = this._defaultPayload;
}
